module.exports = __webpack_public_path__ + "static/img/aboutus_banner@2x.506974f4.jpg";